var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNtrn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_962_6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 6H7.41448L12.8751 12.44C13.7091 11.7074 14.8026 11.2632 15.9999 11.2632C18.6159 11.2632 20.7367 13.384 20.7367 16.0001C20.7367 17.1769 20.3076 18.2534 19.5973 19.0818L26 24.6184L26 26V6ZM23.5986 26L18.5201 20.0115C17.7903 20.4711 16.9261 20.7369 15.9999 20.7369C13.3838 20.7369 11.263 18.6161 11.263 16.0001C11.263 15.0791 11.5258 14.2195 11.9806 13.4923L6 8.33553V26H23.5986Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_962_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNtrn);
export default __webpack_public_path__ + "static/media/NTRN.5676a273665d51075cfd44456321ac60.svg";
export { ForwardRef as ReactComponent };